import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, Select, DatePicker, message } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import {
  DownCircleOutlined,
  FilterOutlined,
  FilterTwoTone,
  ReloadOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useIrnStore } from "../../../store/useIrnstore";
import dayjs from "dayjs";
import { useSelectOptions } from "../../NearToExpiry/storeDivisionSelect";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { useBarcodeStore } from "../../../store/useBarcodeMasterStore";

export const FilterMode = ({ onSearch }) => {
  const { getStore, stores } = useIrnStore();
  const { getCategory, category } = useVendorMasterStore();
  const { getAgingList, agingList } = useBarcodeStore();

  const [formData, setFormData] = useState({
    StoreCode: 0,
    divisionCode: 0,
    date: dayjs(),
  });
  const payload = {
    StoreCode: formData.StoreCode,
    divisionCode: formData.divisionCode,
    date: dayjs(formData.date).startOf("month").format("YYYY-MM-DD"),
  };
  useEffect(() => {
    getStore();
    getCategory();
    getAgingList(payload);
    onSearch(payload)
  }, []);
  const [errors, setErrors] = useState({});
  const storeOptions = useSelectOptions(stores, {
    labelKey: "StoreName",
    valueKey: "StoreCode",
    allLabel: "All",
  });
  const divisionOptions = useSelectOptions(category, {
    labelKey: "DivisionName",
    valueKey: "Division",
    allLabel: "All",
  });

  /* ---------- HANDLERS ---------- */
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  /* ---------- VALIDATION ---------- */
  const validateForm = () => {
    const newErrors = {};

    if (formData.StoreCode === null || formData.StoreCode === undefined) {
      newErrors.StoreCode = "Store is required";
    }
    if (formData.divisionCode === null || formData.divisionCode === undefined) {
      newErrors.divisionCode = "Division is required";
    }
    if (!formData.date) newErrors.date = "To date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------- SEARCH ---------- */
  const handleSearch = async () => {
    if (!validateForm()) {
      return;
    }
    await onSearch(payload);
    console.log("Search Payload:", payload);
    try {
      await getAgingList(payload);
    } catch (error) {
      console.error("Error fetching ageing list:", error);
    }
  };

  return (
    <>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Store"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={storeOptions}
            value={formData.StoreCode}
            onChange={(val) => handleInputChange("StoreCode", val)}
          />
          {errors.StoreCode && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors.StoreCode}
            </span>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Divison"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={divisionOptions}
            value={formData?.divisionCode}
            onChange={(val, option) => {
              handleInputChange("divisionCode", val);
            }}
          />
          {errors.divisionCode && (
            <span style={{ color: "red", fontSize: 12 }}>
              {errors.divisionCode}
            </span>
          )}
        </Col>

        <Col xl={3} md={6}>
          <CustomLabel children={"Date"} isImportnt={false} />
          <DatePicker
            picker="month"
            format="MMM YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={formData.date}
            onChange={(date) => handleInputChange("date", date)}
          />
          {errors.date && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors.date}
            </span>
          )}
        </Col>

        <Col xl={2} style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#64c41aff", // elegant green
              borderColor: "#69c41aff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
            onClick={handleSearch}
          >
            Search
          </Button>
        </Col>
      </Row>
    </>
  );
};
